// Import React and hooks for component logic
import React, { useState, useRef, useEffect } from "react";
// Import Link for navigation between routes
import { Link } from "react-router-dom";
// Import the CSS file for navbar styling
import "../../css/Navbar.css";
// Import the site logo image
import Logo from "../../assets/images/site_logo.png";
// Import useNavigate hook for programmatic navigation
import { useNavigate } from "react-router-dom";

// Navbar component displays the site navigation bar with links and dropdowns
const Navbar = () => {
  // Hook for programmatic navigation
  const navigate = useNavigate();
  // List of calculator dropdown items
  const calculatorsList = [
    { name: "Mortgage Borrow", path: "/calculators/mortgage-borrow" },
    { name: "Mortgage Repayment", path: "/calculators/mortgage-repayment" },
    { name: "Overpayment", path: "/calculators/overpayment" },
    { name: "Stamp Duty", path: "/calculators/stamp-duty" },
    {
      name: "How Much Will It Cost",
      path: "/calculators/how-much-will-it-cost",
    },
    {
      name: "How Much Can I Borrow",
      path: "/calculators/how-much-can-i-borrow",
    },
    { name: "Equity Release", path: "/calculators/equity-release" },
    { name: "Relevant Life Tax", path: "/calculators/relevant-life-tax" },
  ];
  // State to control calculators dropdown visibility
  const [showCalculatorsDropdown, setShowCalculatorsDropdown] = useState(false);
  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo section */}
        <div className="logo">
          <Link to="/">
            <img
              src={Logo}
              alt="Portfolio Finance Logo"
              className="logo-icon"
            />
          </Link>
        </div>
        {/* Navigation menu */}
        <ul className="nav-menu">
          <li>
            <Link to="/about" className="nav-item">
              About Us
            </Link>
          </li>
          <li>
            <Link to="/services" className="nav-item">
              Services
            </Link>
          </li>
          {/* Calculators dropdown menu */}
          <li className="nav-item" style={{ position: "relative" }}>
            <span
              className="nav-item"
              onClick={() => setShowCalculatorsDropdown((prev) => !prev)}
              style={{
                userSelect: "none",
                cursor: "pointer",
                color: showCalculatorsDropdown ? "#F5F5F5" : "#F5F5F5",
              }}
            >
              Calculators
            </span>
            {/* Dropdown list for calculators */}
            {showCalculatorsDropdown && (
              <ul className="navbar-dropdown">
                {calculatorsList.map((calc) => (
                  <li
                    key={calc.name}
                    className="navbar-dropdown-item content"
                    style={{ padding: "0.5rem 1rem" }}
                  >
                    <Link
                      to={calc.path}
                      className="dropdown-link"
                      onClick={() => setShowCalculatorsDropdown(false)}
                    >
                      {calc.name}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
          {/* Uncomment to add Blogs link in the future */}
          {/* <li>
            <Link to="/blogs" className="nav-item">
              Blogs
            </Link>
          </li> */}
          <li>
            <Link to="/contact" className="nav-item">
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

// Export the Navbar component as default
export default Navbar;
